module.exports = __webpack_public_path__ + "static/img/logo文字-1920.b97d3ada.png";